export enum RequestStatusEnum {
  New = 'new',
  InProgress = 'in-progress',
  InReview = 'in-review',
  Completed = 'completed',
  Cancelled = 'cancelled'
}
